export var getDeleteSelectors = function (getBase) {
    return {
        isDeleting: function (rootState, id) { var _a; return (id && ((_a = getBase(rootState).delete[id]) === null || _a === void 0 ? void 0 : _a.isDeleting)) || false; },
        deleteError: function (rootState, id) { var _a; return (id && ((_a = getBase(rootState).delete[id]) === null || _a === void 0 ? void 0 : _a.deleteError)) || undefined; },
    };
};
